// extracted by mini-css-extract-plugin
export var modal = "_ga-0";